import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LiveSection from "./components/LiveSection";
import DanmakuSection from "./components/DanmakuSection";
import ReviewSection from "./components/ReviewSection";
import ReactionSection from "./components/ReactionSection";
import RankingSection from "./components/RankingSection";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  const [subscribed, setSubscribed] = useState(false);

  return (
    <div className="min-h-screen bg-stone-950 text-stone-200">
      <Navbar />

      <main>
        <Hero />
        <LiveSection />
        <DanmakuSection />
        <ReviewSection />
        <ReactionSection />
        <RankingSection />

        {/* 互动订阅条 */}
        <section className="scroll-mt-20 bg-stone-950 py-16 md:py-20">
          <div className="mx-auto max-w-7xl px-4 md:px-6">
            <div className="relative overflow-hidden rounded-3xl border border-orange-500/20 bg-gradient-to-r from-orange-500/15 via-stone-900 to-transparent px-6 py-12 md:px-14 md:py-16">
              <div className="pointer-events-none absolute -right-10 -top-16 h-64 w-64 rounded-full bg-orange-500/20 blur-[90px]" />
              <div className="relative max-w-2xl">
                <h2 className="text-2xl font-black text-white md:text-4xl">热点一冒头，就有人帮你蹲好了</h2>
                <p className="mt-4 text-sm leading-relaxed text-stone-300 md:text-base">
                  订阅 99吃瓜的开播提醒，连麦现场、弹幕合集和反应视频上新第一时间推送，别让自己错过全场最热的那一口。
                </p>
                <form
                  className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center"
                  onSubmit={(e) => {
                    e.preventDefault();
                    setSubscribed(true);
                  }}
                >
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="输入常用邮箱，接收开播提醒"
                    className="h-12 w-full rounded-full border border-white/10 bg-stone-950/70 px-5 text-sm text-white outline-none placeholder:text-stone-500 focus:border-orange-400/60"
                  />
                  <button
                    type="submit"
                    className="h-12 shrink-0 whitespace-nowrap rounded-full bg-orange-500 px-7 text-sm font-semibold text-stone-950 transition-colors hover:bg-orange-400"
                  >
                    {subscribed ? "已订阅 · 随时提醒你" : "订阅开播提醒"}
                  </button>
                </form>
                {subscribed && (
                  <p className="mt-3 text-sm text-orange-300">
                    <i className="ri-checkbox-circle-line mr-1" />
                    订阅成功！有新现场开播会第一时间提醒你。
                  </p>
                )}
                <p className="mt-4 text-xs text-stone-500">示例提醒功能，仅用于当前页面演示，不会发送真实邮件。</p>
              </div>
            </div>
          </div>
        </section>

        <FaqSection />
      </main>

      <Footer />
      <BackToTop />
    </div>
  );
}